<!--  -->
<template>
  <div class=''>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>公司简介</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="mcDialogVisible = true">编辑</el-button>
          </div>
          <div class="content"
               style="padding:10px"
               v-html="oldContent">

          </div>

        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>公司信息</span>
          </div>
          <div class="content home-contact"
               style="padding:10px">
            <div v-for="(item,index) in companies"
                 @mouseenter="inCompany(item,index)"
                 @mouseleave="leaveCompany(item,index)"
                 style="position: relative;">

              <el-row :gutter="20">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  公司类型：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  {{item.type?"总公司":"分公司"}}
                </el-col>
              </el-row>

               <el-row :gutter="20">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  名称：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  {{item.name}}
                </el-col>
              </el-row>

             
              <el-row :gutter="20"
                      v-for="(info,infoIndex) in item.infos">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  {{info.key}}：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  {{info.info}}
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  联系地址：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  {{item.address}}
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  联系邮箱：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  {{item.email}}
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  HR邮箱：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  {{item.hrEmail}}
                </el-col>
              </el-row>

              <el-row :gutter="20"
                      v-for="(tell,tellIndex) in item.tells">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  {{tell.key}}：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  {{tell.tell}}
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="6"
                        style="line-height: 22px;font-weight: 700;">
                  联系地址地图网址：
                </el-col>
                <el-col :span="18"
                        style="line-height: 22px;font-weight: normal;">
                  <!-- <a :href="item.positionUrl"> {{item.positionUrl}}</a> -->
                  {{item.positionUrl}}
                </el-col>
              </el-row>

              <p style="margin: 20px;border-bottom: 1px #314478 solid;"></p>

              <div v-bind:class="[item.in ? '' : 'action-hidden']"
                   style="position: absolute;top: 0;right: 0;">
                <a @click="contactDialogVisible = true;contactData=JSON.parse(JSON.stringify(item));editCompanyState=true;"
                   style="color: cornflowerblue;font-size: 90%;cursor: pointer;margin-right:10px;padding:5px;">编辑</a>
                <a @click="contactDialogVisible = true"
                   style="color: cornflowerblue;font-size: 90%;cursor: pointer;margin-right:20%;padding:5px;">删除</a>
              </div>

            </div>

            <div class="Item-add">
              <a @click="contactDialogVisible = true;contactData={infos:[{}],tells:[{}]};editCompanyState=false">-
                新增公司信息 -</a>
            </div>

          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>问候</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="greetingsDialogVisible = true">编辑
            </el-button>
          </div>
          <div class="content"
               style="padding:10px"
               v-html="greetingsContent">

          </div>

        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>管理理念</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="philosophyDialogVisible = true">编辑
            </el-button>
          </div>
          <div class="content"
               style="padding:10px"
               v-html="philosophyContent">

          </div>

        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>历史事件</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="historyDialogVisible = true">新增
            </el-button>
          </div>
          <div class="content">
            <table class="history-table edit-list">
              <tr v-for="(item , index) in historys">
                <th valign="top">
                  <p style="float: left;">{{item.historyDate.substring(0,5)}}</p>
                  <p style="padding-left: 0.6em; padding-right: 0.6em;float: right;">{{item.historyDate.substring(5,8)}}
                  </p>
                </th>
                <td valign="top">
                  <p>
                    {{item.historyContent}}
                  </p>
                  <a style="float:right;cursor:pointer"
                     @click="delHistory(item)">删除</a>
                </td>
              </tr>

            </table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="新增历史事件"
               :visible.sync="historyDialogVisible"
               width="1070px">
      <div class="home-contact"
           style="padding:0 15px;">

        <el-row :gutter="20">
          <el-col :span="6">
            <span> 发生时间：</span>
          </el-col>
          <el-col :span="18">
            <el-date-picker v-model="newHistory.historyDate"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            :picker-options="pickerOptions1">
            </el-date-picker>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6">
            <span> 发生事件：</span>
          </el-col>
          <el-col :span="18">
            <el-input placeholder="请输入内容"
                      type="textarea"
                      v-model="newHistory.historyContent"
                      rows="5"
                      clearable>
            </el-input>
          </el-col>
        </el-row>

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="historyDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="addHistory">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置公司基本信息"
               :visible.sync="contactDialogVisible"
               width="980px">

      <div class="home-contact"
           style="padding:0 15px;">

        <div>

          <el-row :gutter="20">
            <el-col :span="6">
              <span> 公司类型 ：</span>
            </el-col>
            <el-col :span="18"
                    style="    line-height: 40px;">

              <el-switch style="display: block"
                         v-model="contactData.type"
                         active-color="#13ce66"
                         inactive-color="#ff4949"
                         active-text="总公司"
                         inactive-text="分公司">
              </el-switch>
              <!-- <el-switch v-model="contactData.type"
                           active-value="总公司"
                           inactive-value="分公司"
                           active-color="#13ce66"
                           inactive-color="#ff4949"> -->
              </el-switch>
            </el-col>
          </el-row>

          <div style="display: flex">公司信息 <a style="margin-left: 10px;color: cornflowerblue;cursor:pointer;"
               @click="addInfo">新增</a></div>

        <el-row :gutter="20">
          <el-col :span="6">
            <span> 名称：</span>
          </el-col>
          <el-col :span="18">
            <el-input placeholder="请输入内容"
                      clearable
                      v-model="contactData.name">
            </el-input>
          </el-col>
        </el-row>

          <el-row v-for="(item, index) in contactData.infos"
                  :key="index"
                  :gutter="20">
            <el-col :span="6"
                    style="text-align: right;">
              <el-input placeholder="请输入内容"
                        clearable
                        v-model="item.key">
              </el-input>
            </el-col>
            <el-col :span="16">
              <el-input placeholder="请输入内容"
                        clearable
                        v-model="item.info">
              </el-input>
            </el-col>
            <el-col :span="2"
                    style="text-align: left;">
              <span style="cursor:pointer;color: orange"
                    @click="delInfo(index)"
                    v-if="index != 0">删除</span>
            </el-col>
          </el-row>

        </div>

        <el-row :gutter="20">
          <el-col :span="6">
            <span> 联系地址：</span>
          </el-col>
          <el-col :span="18">
            <el-input placeholder="请输入内容"
                      clearable
                      v-model="contactData.address">
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <span> 联系邮箱：</span>
          </el-col>
          <el-col :span="18">
            <el-input placeholder="请输入内容"
                      clearable
                      v-model="contactData.email">
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <span> HR邮箱：</span>
          </el-col>
          <el-col :span="18">
            <el-input placeholder="请输入内容"
                      clearable
                      v-model="contactData.hrEmail">
            </el-input>
          </el-col>
        </el-row>

        <div>
          <div style="display: flex">联系电话 <a style="margin-left: 10px;color: cornflowerblue;cursor:pointer;"
               @click="addTell">新增</a></div>

          <el-row v-for="(item, index) in contactData.tells"
                  :key="index"
                  :gutter="20">
            <el-col :span="6"
                    style="text-align: right;">
              <el-input placeholder="请输入内容"
                        clearable
                        v-model="item.key">
              </el-input>
            </el-col>
            <el-col :span="16">
              <el-input placeholder="请输入内容"
                        clearable
                        v-model="item.tell">
              </el-input>
            </el-col>
            <el-col :span="2"
                    style="text-align: left;">
              <span style="cursor:pointer;color: orange"
                    @click="delTell(index)"
                    v-if="index != 0">删除</span>
            </el-col>
          </el-row>
        </div>

        <el-row :gutter="20">
          <el-col :span="6">
            <span> 联系地址地图网址：：</span>
          </el-col>
          <el-col :span="18">
            <el-input placeholder="请输入内容"
                      clearable
                      v-model="contactData.positionUrl">
            </el-input>
          </el-col>
        </el-row>

      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="contactDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editCompany">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑公司简介"
               :visible.sync="mcDialogVisible"
               width="1070px">

      <editor api-key="agxxiyg1jdutxaedi814x27cnp8iylepymvoxkllzqghmhdi"
              :init="editorConf"
              v-model="oldContent">
      </editor>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="mcDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editMc">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑问候"
               :visible.sync="greetingsDialogVisible"
               width="1070px">

      <editor api-key="agxxiyg1jdutxaedi814x27cnp8iylepymvoxkllzqghmhdi"
              :init="editorConf"
              v-model="greetingsOldContent">
      </editor>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="greetingsDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editGreetings">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑管理理念"
               :visible.sync="philosophyDialogVisible"
               width="1070px">

      <editor api-key="agxxiyg1jdutxaedi814x27cnp8iylepymvoxkllzqghmhdi"
              :init="editorConf"
              v-model="philosophyOldContent">
      </editor>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="philosophyDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editPhilosophy">确 定</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog title="编辑公司简介" :visible.sync="mcDialogVisible" width="1070px">

      <editor api-key="agxxiyg1jdutxaedi814x27cnp8iylepymvoxkllzqghmhdi" :init="editorConf" v-model="oldContent">
      </editor>

      <span slot="footer" class="dialog-footer">
        <el-button @click="mcDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editMc">确 定</el-button>
      </span>
    </el-dialog> -->

  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

var Editor = require("@tinymce/tinymce-vue").default;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    editor: Editor // <- Important part
  },
  data() {
    //这里存放数据
    return {
      philosophyDialogVisible: false,
      historyDialogVisible: false,
      philosophyOldContent: "",
      philosophyContent: "",
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      mcContent: "",
      newHistory: {},
      historys: [],
      value2: "",
      mcDialogVisible: false,
      content: "",
      oldContent: "",
      greetingsContent: "",
      greetingsOldContent: "",
      greetingsDialogVisible: false,
      editCompanyState: false, //0：新增。1:编辑
      companies: [],
      contactData: {},
      contactDialogVisible: false
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    addHistory() {
      var that = this;
      var url = "/api/admin/company/addHistory";
      this.$request.post({
        url: url,
        params: that.newHistory,
        callback: {
          success: function(data) {
            that.historyDialogVisible = false;
            that.historys = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    delHistory(history) {
      var that = this;
      this.$alert("是否删除该历史事件", "提示", {
        confirmButtonText: "确定",
        callback: action => {
          if (action == "confirm") {
            var url = "/api/admin/company/delHistory";
            this.$request.post({
              url: url,
              params: history,
              callback: {
                success: function(data) {
                  that.historyDialogVisible = false;
                  that.historys = data.data;
                },
                err: function(err) {
                  console.log(err);
                }
              }
            });
          }
        }
      });
    },
    editPhilosophy() {
      var that = this;
      var url = "/api/admin/cover/management_t";
      this.$request.post({
        url: url,
        params: { html: that.philosophyOldContent },
        callback: {
          success: function(data) {
            that.greetingsDialogVisible = false;
            that.philosophyOldContent = data.data;
            that.philosophyContent = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    editGreetings() {
      var that = this;
      var url = "/api/admin/cover/greetings_t";
      this.$request.post({
        url: url,
        params: { html: that.greetingsOldContent },
        callback: {
          success: function(data) {
            that.greetingsDialogVisible = false;
            that.greetingsContent = data.data;
            that.greetingsOldContent = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    editMc() {
      var that = this;
      var url = "/api/admin/cover/company_t";
      this.$request.post({
        url: url,
        params: { html: that.oldContent },
        callback: {
          success: function(data) {
            that.mcDialogVisible = false;
            that.content = data.data;
            that.oldContent = that.content;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    editCompany() {
      var that = this;
      var url = "";
      if (that.editCompanyState) {
        url = "/api/admin/company/updateCompany";
      } else {
        url = "/api/admin/company/addCompany";
      }
      this.$request.post({
        url: url,
        params: that.contactData,
        callback: {
          success: function(data) {
            that.contactDialogVisible = false;
            var companies = data.data;
            for (var index in companies) {
              companies[index].infos = JSON.parse(companies[index].infos);
              companies[index].tells = JSON.parse(companies[index].tells);
            }
            that.companies = companies;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    inCompany(company, index) {
      if (company.in === undefined) {
        this.$set(company, "in", true);
      }
      company.in = true;
    },
    leaveCompany(company, index) {
      company.in = false;
    },
    addTell() {
      this.contactData.tells.push({});
    },
    delTell(index) {
      this.contactData.tells.splice(index, 1);
    },
    addInfo() {
      this.contactData.infos.push({});
    },
    delInfo(index) {
      this.contactData.infos.splice(index, 1);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this;
    this.$request.get({
      url: "/api/pageData/admin/company",
      callback: {
        success: function(data) {
          // that.forewordDialogVisible = false;
          var companies = data.data.companies;
          for (var index in companies) {
            companies[index].infos = JSON.parse(companies[index].infos);
            companies[index].tells = JSON.parse(companies[index].tells);
          }
          that.companies = companies;
          that.oldContent = data.data.content;
          that.content = data.data.content;
          
          that.greetingsContent = data.data.greetings;
          that.greetingsOldContent = data.data.greetings;

          that.philosophyOldContent = data.data.management;
          that.philosophyContent = data.data.management;
          that.historys = data.data.historys;
        },
        err: function(err) {
          console.log(err);
        }
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.box-card {
  margin: 20px;
}

.box-card .el-card__body {
  padding: 0;
}

.edit-list a {
  color: red;
}

.home-contact .el-date-editor {
  width: 100%;
}

.history-table {
  margin: 20px auto;
  width: calc(100% - 100px);
}

.history-table th {
  display: table-cell;
  width: 120px;
  background-color: #fff;
  border-right: #bbb 1px solid;
  font-size: 95%;
}

.history-table td {
  vertical-align: top;
  padding-right: 0;
  padding-left: 10px;
  padding-bottom: 15px;
  display: table-cell;
  font-size: 95%;
}
</style>